// extracted by mini-css-extract-plugin
module.exports = {"quickSearch":"QuickSearch_quickSearch__lQFQd","icon":"QuickSearch_icon__2MJ_I"};